$(document).ready(function(){

    var map_zoom = 1.5;

    $('.js-enlarge-map').click(function(){

        let max_zoom = 2.5;
        if(map_zoom > max_zoom){
            return;
        }

        map_zoom += 0.5;
        $('.hp-map').css('transform', 'scale(' + map_zoom + ')');
    });

    $('.js-shrink-map').click(function(){
        let min_zoom = 1;

        if(map_zoom <= min_zoom){
            return;
        }
        map_zoom -= 0.5;
        $('.hp-map').css('transform', 'scale('+ map_zoom +')');
    });



    // Dragovanie
    var dragging = false;
    var startX, startY, currentX = 0, currentY = 0;
    var map = $('.js-hp-map');

    map.mousedown(function (e) {
        dragging = true;
        startX = e.pageX - currentX;
        startY = e.pageY - currentY;
        map.css('cursor', 'grabbing');
        console.log('mousedown');
    });

    // Zabránime predvolenému ťahaniu obrázka
    map.on('dragstart', function (e) {
        e.preventDefault();
    });

    map.mouseup(function () {
        dragging = false;
        map.css('cursor', 'grab');
        console.log('mouseup');
    });

    map.mousemove(function (e) {
        if (dragging) {
            currentX = e.pageX - startX;
            currentY = e.pageY - startY;
            map.css({
                top: currentY + 'px',
                left: currentX + 'px'
            });

            console.log('mousemove' + 'top: ' + currentY + 'px left: ' + currentX + 'px');
        }
    });
})
